// Shared layout wrapper for legal / info pages
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Header from './Header';
import { useLang } from '../context/LanguageContext';

const LegalLayout = ({ title, subtitle, children, lastUpdated }) => {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#0d0e10] text-white">
      <Header />
      <main className="px-4 md:px-8 py-8">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-sm text-white/60 hover:text-[#ff4e15] transition-colors mb-6"
            data-testid="legal-back-link"
          >
            <ChevronLeft size={14} /> {t('backToHome')}
          </Link>

          <div className="fade-in-up">
            <h1 className="heading-font text-4xl md:text-5xl font-black tracking-wide">
              {title}
            </h1>
            {subtitle && <p className="mt-2 text-white/70 text-base">{subtitle}</p>}
            {lastUpdated && (
              <p className="mt-2 text-xs text-white/40">{t('lastUpdated')}: {lastUpdated}</p>
            )}
          </div>

          <div className="mt-8 space-y-6 text-white/80 text-[15px] leading-relaxed legal-content">
            {children}
          </div>

          <div className="mt-16 pt-8 border-t border-[#1f2024] text-xs text-white/50">
            <p>{t('needHelp')} <a className="text-[#ff4e15] hover:underline" href="mailto:support@myhealthyfy.com">support@myhealthyfy.com</a></p>
            <p className="mt-2">{t('footerRights')}</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export const Section = ({ title, children }) => (
  <section>
    <h2 className="text-xl md:text-2xl font-bold text-white mb-3">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export const Bullet = ({ children }) => (
  <li className="flex items-start gap-2">
    <span className="w-1.5 h-1.5 rounded-full bg-[#ff4e15] mt-2 shrink-0" />
    <span>{children}</span>
  </li>
);

export default LegalLayout;
